import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { inject, Injectable } from '@angular/core';
import { AccountManagementService } from '@core/services/account-management.service';
import { TableActions } from '../table.actions';
import { NotificationFacade } from '@core/facades/notification.facade';
import { getDefaultTableState } from '../table.state';
import { RelationshipManagerService } from '@core/services/relationship-manager.service';

@Injectable({
  providedIn: 'root',
})
export class AccountsRMHandler {
  constructor() {}
  accountRMService = inject(RelationshipManagerService);
  notify = inject(NotificationFacade);

  handleAccountsRMLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.accountRMService.getAllAccounts({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'accountsRM',
            data: response.data?.list,
            totalCount: response.data?.count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'accountsRM',
            error: error.message,
          })
        );
      },
    });
  }

  handleGetMetadata(ctx: StateContext<TableStateModel>) {
    return this.accountRMService.getAccountRMListMetaData().subscribe({
      next: (response) => {
        const currentState = ctx.getState();

        const currentAccount =
          currentState.accountsRM || getDefaultTableState();

        ctx.patchState({
          accountsRM: {
            ...currentAccount,
            accountRMMetadata: response.data,
          },
        });
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.GetAccountsMetadataFailure({
            error: error.message,
          })
        );
      },
    });
  }

  getAccountsMetadataSuccess(
    ctx: StateContext<TableStateModel>,
    action: TableActions.GetAccountsRMMetadataSuccess
  ) {
    const currentState = ctx.getState();

    const currentAccount = currentState.accountsRM || getDefaultTableState();

    ctx.patchState({
      accountsRM: {
        ...currentAccount,
        accountRMMetadata: action.payload.accountRMMetadata,
      },
    });
  }

  getAccountsMetadataFailure(
    ctx: StateContext<TableStateModel>,
    action: TableActions.GetAccountsRMMetadataFailure
  ) {
    const currentState = ctx.getState();
    const currentAccount = currentState.accountsRM || getDefaultTableState();

    ctx.patchState({
      accountsRM: {
        ...currentAccount,
        error: action.payload.error,
      },
    });
  }

    filterAccountRMList(
      ctx: StateContext<TableStateModel>,
      action: TableActions.FilterAccountRMList
    ) {
      return this.accountRMService
        .getAllAccounts(undefined, action.payload.filter)
        .subscribe({
          next: (response) => {
            ctx.dispatch(
              new TableActions.LoadTableDataSuccess({
                tableKey: 'accountsRM',
                data: response.data?.list,
                totalCount: response.data?.count,
              })
            );
          },
          error: (error) => {
            ctx.dispatch(
              new TableActions.LoadTableDataFailure({
                tableKey: 'accountsRM',
                error: error.message,
              })
            );
          },
        });
    }

   handleRelationshipManagersLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.accountRMService.getAllRMs().subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'relationshipManagers',
            data: response.data,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'relationshipManagers',
            error: error.message,
          })
        );
      },
    });
  }

}
